import {
  IdentityFragment,
  SearchV1ExternalSearchRequestFiltersIdentityFilterKind,
  getTypeOrNull,
} from '@spotify/confidence-graphql';

export const getIdentityDescription = (
  identity: IdentityFragment,
  fallback: string | undefined = undefined,
): string | undefined => {
  return (
    getTypeOrNull(identity?.group)?.description ??
    getTypeOrNull(identity?.apiClient)?.description ??
    (identity?.everyone ? 'All users in this workspace' : undefined) ??
    fallback
  );
};

export type IdentityKind =
  | 'user'
  | 'group'
  | 'apiClient'
  | 'everyone'
  | 'service'
  | 'agent';

export const identityKindToFilter: Record<
  IdentityKind,
  SearchV1ExternalSearchRequestFiltersIdentityFilterKind
> = {
  user: SearchV1ExternalSearchRequestFiltersIdentityFilterKind.User,
  group: SearchV1ExternalSearchRequestFiltersIdentityFilterKind.Group,
  apiClient: SearchV1ExternalSearchRequestFiltersIdentityFilterKind.ApiClient,
  everyone: SearchV1ExternalSearchRequestFiltersIdentityFilterKind.Everyone,
  service: SearchV1ExternalSearchRequestFiltersIdentityFilterKind.Service,
  agent: SearchV1ExternalSearchRequestFiltersIdentityFilterKind.Agent,
};

export const identityKind = (name: string): IdentityKind => {
  if (name.startsWith('identities/u')) {
    return 'user';
  }

  if (name.startsWith('identities/g')) {
    return 'group';
  }

  if (name.startsWith('identities/c')) {
    return 'apiClient';
  }

  if (name.startsWith('identities/everyone')) {
    return 'everyone';
  }

  if (name.startsWith('identities/s')) {
    return 'service';
  }

  if (name.startsWith('identities/a')) {
    return 'agent';
  }

  throw new Error(`Invalid identity name: ${name}`);
};
